import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email({ message: 'Enter a valid email address.' }),
  password: z.string().min(1, { message: 'Password is required.' }),
});

export type LoginFormValues = z.infer<typeof loginSchema>;

const passwordComplexity = z
  .string()
  .min(8, { message: 'Password must be at least 8 characters.' })
  .regex(/[A-Z]/, { message: 'Include at least one uppercase letter.' })
  .regex(/[a-z]/, { message: 'Include at least one lowercase letter.' })
  .regex(/[0-9]/, { message: 'Include at least one number.' })
  .regex(/[^A-Za-z0-9]/, { message: 'Include at least one special character.' });

const southAfricaMobile = z
  .string()
  .trim()
  .transform((value) => value.replace(/\s+/g, ''))
  .pipe(
    z
      .string()
      .regex(/^(?:\+27|0)[6-8]\d{8}$/, {
        message: 'Enter a valid South African mobile number.',
      }),
  );

export const registerSchema = z.object({
  firstName: z.string().trim().min(1, { message: 'First name is required.' }),
  lastName: z.string().trim().min(1, { message: 'Last name is required.' }),
  email: z.string().email({ message: 'Enter a valid email address.' }),
  mobileNumber: southAfricaMobile,
  password: passwordComplexity,
});

export type RegisterFormValues = z.infer<typeof registerSchema>;

export const forgotPasswordSchema = z.object({
  email: z.string().email({ message: 'Enter a valid email address.' }),
});

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;
